import * as React from 'react'

type Props = {
  fontSize?: string
  inline?: boolean
}

export function Upsell(props: Props) {
  const { fontSize = '12px', inline = false } = props
  return (
    <div style={{ fontSize: fontSize, display: inline ? 'inline' : 'block' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
      >
        <g fill="#045CA4">
          <path d="M4.95 3.9L3.825 4.95 7.5 8.55 15 1.05 13.95 0 7.5 6.45z" />
          <path d="M11.925 6.075c.075.225.075.45.075.675C12 9.675 9.675 12 6.75 12S1.5 9.675 1.5 6.75 3.825 1.5 6.75 1.5c.9 0 1.8.225 2.625.675L10.125.9C9.075.3 7.95 0 6.75 0 3 0 0 3 0 6.75s3 6.75 6.75 6.75 6.75-3 6.75-6.75c0-.3 0-.525-.075-.825l-1.5.15z" />
        </g>
      </svg>
      &nbsp;Upsell
    </div>
  )
}
